import { corporateOnEnterSaga } from './Corporate.onenter.saga'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var CorporateRoute = function CorporateRoute(store, client) {
  return {
    path: 'corporate/:msaAlias/:corporatePartner',
    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(corporateOnEnterSaga, client, nextState, replaceState).done.then(cb, cb);
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('containers/CmsPage/CmsPage').CmsPage
        });
      }, 'corporate');
    }
  };
};